export default __webpack_public_path__ + "static/media/configr-radio.01a36a9e.svg";